export default "/dist/files/icone_shopping.a308dcd8a47c52bc4dbe6c7bdc102f45.svg";